export const DASHBOARD_PADDING_SIZE = '$4';
